import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

// TODO: On Push
@Component({
  standalone: false,
  selector: 'lib-sub-page-layout',
  templateUrl: './sub-page-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./sub-page-layout.component.scss']
})
export class SubPageLayoutComponent implements OnInit {
  @Input() useSideBar = true;
  @Input() useNav = true;
  @Input() sideNavWidth = 'normal';
  @Input() defaultClosed = false;
  constructor() {}

  ngOnInit(): void {}

  setSideNavWidth() {
    if (this.sideNavWidth == 'wide') return 'wide';
    return '';
  }
}
